import React from 'react'
import elevation from '../../../../../lib/api/elevation'
import { waitForGoogleMaps } from '../../../../map/maploader/maploader';

let ShapeLabel;

waitForGoogleMaps(() => {
  ShapeLabel = class extends google.maps.OverlayView {
    constructor(position, content, yOffset) {
      super()
      this.position = position
      this.container = document.createElement('div')
      this.container.appendChild(content)
      this.container.classList.add('map-label')
      this.yOffset = yOffset
    }
    onAdd() {
      this.getPanes().floatPane.appendChild(this.container)
    }
    onRemove() {
      this.container.parentElement.removeChild(this.container)
    }
    draw() {
      const pxPosition = this.getProjection().fromLatLngToDivPixel(this.position)
      this.container.style.left = `${pxPosition.x}px`
      this.container.style.top = `${pxPosition.y}px`
      this.container.style.transform = `translate(-50%, ${this.yOffset}`
    }
  }
})

let shapeInfoBox;

waitForGoogleMaps(() => {
  shapeInfoBox = class extends google.maps.OverlayView {
    constructor(content, shape) {
      super();
      this.container = document.createElement('div');
      this.container.style.position = 'absolute';
      this.container.style.width = '200px';
      this.container.appendChild(content);
      this.shape = shape;
      this.updateShapeContent = this.updateShapeContent.bind(this);
      const close = document.createElement('div');
      this.container.appendChild(close);
      close.style.backgroundImage = 'url(../../../../../../../../asset/Close-X_Thin_FFFFFF_ldpi.png)';
      close.style.backgroundSize = 'contain';
      close.style.position = 'relative';
      close.style.width = '10px';
      close.style.height = '10px';
      close.style.cursor = 'pointer';
      close.style.left = '60%';
      close.style.top = '90px';
      close.style.transform = 'translate(calc(-100% - 10px))';
      close.addEventListener('click', () => {
        this.setMap(null);
      });
    }

    // Method to update the content of the info box and re-render
    updateShapeContent(shape, content, shouldRedraw = true) {
      // Clear existing content
      while (this.container.firstChild) {
        this.container.removeChild(this.container.firstChild);
      }

      // Update the shape and add new content
      this.shape = shape;
      this.container.appendChild(content);

      // Add close button again after content update
      this.addCloseButton();

      // Redraw the info box after updating content
      if (shouldRedraw) {
        this.draw();
      }
    }

    addCloseButton() {
      const close = document.createElement('div');
      this.container.appendChild(close);
      close.style.backgroundImage = 'url(../../../../../../../../asset/Close-X_Thin_FFFFFF_ldpi.png)';
      close.style.backgroundSize = 'contain';
      close.style.position = 'relative';
      close.style.width = '10px';
      close.style.height = '10px';
      close.style.cursor = 'pointer';
      // close.style.left = '100%';
      // close.style.top = '10px';
      close.style.left = '60%';
      close.style.top = '90px';
      close.style.transform = 'translate(calc(-100% - 10px))';
      close.addEventListener('click', () => {
        this.setMap(null);
      });
    }

    // Called when the info box is added to the map
    onAdd() {
      const panes = this.getPanes();
      panes.overlayLayer.appendChild(this.container);
    }

    // Called each time the overlay's position needs to be redrawn
    draw() {
      const overlayProjection = this.getProjection();
      let position;

      // Get the path and check its length
      if (this.shape.getPath) {
        const path = this.shape.getPath();
        const length = path.getLength();

        // Check if the path has at least one point
        if (length > 0) {
          // Use the last point in the path for positioning
          position = path.getAt(length - 1); // Get the last point
        }
      }

      // If the shape has bounds, you can also consider using them
      if (this.shape.getBounds) {
        position = this.shape.getBounds() && this.shape.getBounds().getCenter(); // Optional: You can use the center of bounds
      }

      // Convert the latLng position to pixel coordinates on the map
      if (position) {
        const point = overlayProjection.fromLatLngToDivPixel(position);
        this.container.style.left = `${point.x + 10}px`; // Position it 10px to the right of the shape
        this.container.style.top = `${point.y - 50}px`;  // Adjust the vertical offset if necessary
      }
    }

    // Called when the info box is removed from the map
    onRemove() {
      if (this.container.parentNode) {
        this.container.parentNode.removeChild(this.container);
      }
    }
  }
})

export const shapeUtils = {
  create(type, properties) {
    switch (type) {
      case 'line':
        return new google.maps.Polyline({
          strokeColor: properties.color
        })
      case 'polygon':
        return new google.maps.Polygon({
          strokeColor: properties.color,
          fillColor: properties.color
        })
      case 'circle':
        return new google.maps.Circle({
          strokeColor: properties.color,
          fillColor: properties.color,
          editable: true
        })
    }
  },
  createGeoPolygon(shape, threed, color, fillColor) {
    let coords;

    if (threed && Array.isArray(shape?.outerCoordinates)) {
      coords = shape.outerCoordinates.map(pt => [pt.lng, pt.lat]);
    }

    else if (!threed && typeof shape?.getPath === "function") {
      coords = shape.getPath().getArray().map(pt => [
        pt.lng(),
        pt.lat()
      ]);
    }

    if (!coords || coords.length < 3) {
      console.error("Invalid polygon coords:", shape);
      return null;
    }

    const first = coords[0];
    const last = coords[coords.length - 1];
    if (first[0] !== last[0] || first[1] !== last[1]) {
      coords.push(first);
    }

    return JSON.stringify({
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [coords]
          },
          properties: {
            line: {
              color: color,
              fill: fillColor,
              width: 2,
              style: "solid"
            }
          }
        }
      ]
    });
  },

  addInfoBox(shape, entries) {
    const infoContentBox = document.createElement('div'),
      infoHeader = document.createElement('p')
    infoHeader.innerText = entries.header
    infoContentBox.appendChild(infoHeader)
    infoContentBox.classList.add('shape-infobox-container')
    infoHeader.classList.add('shape-infobox-header')

    entries.entries.forEach(entry => {
      const entryEle = document.createElement('p'),
        entryStr = entry.join(': ')
      entryEle.innerText = entryStr
      entryEle.classList.add('shape-infobox-entry')
      infoContentBox.appendChild(entryEle)
    })

    return new shapeInfoBox(infoContentBox, shape)
  },
  updateInfoBox(shape, entries, box, shouldRedraw = true) {
    const infoContentBox = document.createElement('div'),
      infoHeader = document.createElement('p');
    infoHeader.innerText = entries.header;
    infoContentBox.appendChild(infoHeader);
    infoContentBox.classList.add('shape-infobox-container');
    infoHeader.classList.add('shape-infobox-header');

    entries.entries.forEach(entry => {
      const entryEle = document.createElement('p'),
        entryStr = entry.join(': ');
      entryEle.innerText = entryStr;
      entryEle.classList.add('shape-infobox-entry');
      infoContentBox.appendChild(entryEle);
    });

    box.updateShapeContent(shape, infoContentBox, shouldRedraw);
  },
  createLabel(props) {
    const { coord, content, yOffset } = props
    return new ShapeLabel(coord, content, yOffset)
  },
  getLabelOffsets(coord1, coord2) {
    return Math.abs(coord1) < Math.abs(coord2) ? '-100%' : '0%'
  },
  addLabels(shape) {
    const path = shape.getPath()
    return path.getArray().map((coord, idx) => {
      const content = document.createElement('div'),
        copyLat = document.createElement('p'),
        copyLng = document.createElement('p'),
        yOffset = idx < path.getLength() - 1 ?
          this.getLabelOffsets(path.getAt(idx + 1).lat(), coord.lat()) :
          this.getLabelOffsets(path.getAt(idx - 1).lat(), coord.lat())
      copyLat.innerHTML = `Lat: ${Math.round(coord.lat() * 1000000) / 1000000}`
      copyLng.innerHTML = `Lng: ${Math.round(coord.lng() * 1000000) / 1000000}`
      content.appendChild(copyLat)
      content.appendChild(copyLng)
      return this.createLabel({ coord, content, yOffset })
    })
  },
  addDetailLabel(shape) {

  },
  // createGeoLine(shape, threed) {

  //   let coordinates;
  //   let color = shape?.strokeColor || "#0009F9";

  //   if (threed && Array.isArray(shape.coordinates)) {
  //     coordinates = shape?.coordinates.map(pt => [pt.lng, pt.lat]);
  //   }

  //   else if (!threed && shape.getPath) {
  //     coordinates = shape?.getPath().getArray().map(pt => [
  //       pt.lng(),
  //       pt.lat()
  //     ]);
  //   }

  //   if (!coordinates || coordinates.length < 2) {
  //     console.error("Invalid coordinates passed to createGeoLine:", shape);
  //     return null;
  //   }

  //   return JSON.stringify({
  //     type: "FeatureCollection",
  //     features: [
  //       {
  //         type: "Feature",
  //         geometry: {
  //           type: "LineString",
  //           coordinates
  //         },
  //         properties: {
  //           line: {
  //             color,
  //             width: 2,
  //             style: "solid"
  //           }
  //         }
  //       }
  //     ]
  //   });
  // },

  createGeoLine(shape, threed, style = 'solid', width = 2) {
    let coordinates = [];
    const color = shape?.strokeColor || "#0009F9";

    // ---- 3D / GeoJSON-like shapes ----
    if (
      threed &&
      Array.isArray(shape?.coordinates)
    ) {
      coordinates = shape.coordinates
        .filter(pt => pt && pt.lat != null && pt.lng != null)
        .map(pt => [
          typeof pt.lng === "function" ? pt.lng() : pt.lng,
          typeof pt.lat === "function" ? pt.lat() : pt.lat
        ]);
    }

    // ---- 2D Google Maps Polyline / Polygon ----
    else if (
      !threed &&
      typeof shape?.getPath === "function"
    ) {
      const path = shape.getPath()?.getArray?.() || [];
      coordinates = path.map(pt => [pt.lng(), pt.lat()]);
    }

    // ---- Final validation ----
    if (coordinates.length < 2) {
      console.log("Invalid coordinates passed to createGeoLine", {
        threed,
        shapeType: shape?.constructor?.name,
        coordinates,
        shape
      });
      return null;
    }

    // ---- GeoJSON output ----
    return JSON.stringify({
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates
          },
          properties: {
            line: {
              color,
              width,
              style
            }
          }
        }
      ]
    });
  },


  createGeoPoly(shape, width = 2) {
    let coordinates = shape?.getPath()?.getArray().map(coord => [coord.lng(), coord.lat()])
    coordinates.unshift([coordinates[coordinates.length - 1][0], coordinates[coordinates.length - 1][1]])
    return JSON.stringify({
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            coordinates: [coordinates]
          },
          properties: {
            line: {
              color: shape.strokeColor,
              width,
              fill: shape.fillColor
            }
          }
        }
      ]
    })
  },
  createGeoCircle(shape, width = 2) {
    const point = shape.getCenter()
    return JSON.stringify({
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [point.lng(), point.lat()]
          },
          properties: {
            line: {
              color: shape.strokeColor,
              fill: shape.fillColor,
              fillOpacity: 0.4,
              width
            },
            radius: shape.getRadius()
          }
        }
      ]
    })
  },
  getArea(shape, units, ignoreCount = 0) {
    if (shape) {
      const coords = shape.getPath().getArray().slice(0, shape.getPath().getLength() - ignoreCount),
        scale = units === 'imperial' ? 0.000247105 : 0.0001,
        computedArea = Math.round(google.maps.geometry.spherical.computeArea(coords) * scale * 100) / 100
      return computedArea
    }
  },

  getLength(shape, units, ignoreCount = 0) {
    const denom = units === "imperial" ? 1609.344 : 1000;

    let coords;

    if (Array.isArray(shape.coordinates)) {
      coords = shape?.coordinates.map(pt =>
        new google.maps.LatLng(pt.lat, pt.lng)
      );
    }

    else if (shape.getPath) {
      coords = shape
        .getPath()
        .getArray()
        .slice(0, shape?.getPath().getLength() - ignoreCount);
    }

    let length = 0;

    coords.forEach((pt, idx) => {
      if (idx > 0) {
        length +=
          google.maps.geometry.spherical.computeDistanceBetween(
            pt,
            coords[idx - 1]
          ) / denom;
      }
    });

    return length;
  },

  getElevationGain(shape, token, ignoreCount = 0) {
    if (typeof shape?.getPath === "function") {
      const coords = shape?.getPath?.().getArray().slice(0, shape?.getPath()?.getLength() - ignoreCount),
        eles = coords?.map(coord => elevation?.getElevation(coord.lat(), coord.lng(), token))
      return new Promise((resolve, reject) => {
        Promise.all(eles)
          .then(res => {
            let gain = 0
            if (res.length > 1) {
              gain = 0
              for (let i = 0; i < res.length - 1; i++) {
                if (res[i + 1] > res[i]) {
                  gain = gain + res[i + 1] - res[i];
                }
              }
            }
            resolve(gain)
          })
          .catch(err => {
            console.error('Could not fetch elevations:', err)
            reject()
          })
      })
    }
  },

  // Fetch per-vertex elevations for a line and return both the elevation gain and the
  // full elevations array (aligned to the kept coords). Single fetch — uses the cache
  // incrementally when exactly one point was appended, otherwise refetches all. Feeds
  // both the "Elevation Gain" stat and the live elevation profile (WEB-7020).
  getLineElevation(shape, token, ignore = 0, cache = null) {
    if (typeof shape?.getPath !== 'function') return Promise.reject('no path')
    const coords = shape.getPath().getArray().slice(0, shape.getPath().getLength() - ignore)
    const computeGain = eles => {
      let gain = 0
      for (let i = 0; i < eles.length - 1; i++) if (eles[i + 1] > eles[i]) gain += eles[i + 1] - eles[i]
      return gain
    }
    const done = eles => ({ gain: computeGain(eles), elevations: eles.slice(), coords })
    if (cache && cache.length === coords.length - 1 && coords.length > 0) {
      const nc = coords[coords.length - 1]
      return elevation.getElevation(nc.lat(), nc.lng(), token).then(newEle => {
        cache.push(newEle)
        return done(cache)
      })
    }
    return Promise.all(coords.map(coord => elevation.getElevation(coord.lat(), coord.lng(), token)))
      .then(results => {
        if (cache) { cache.length = 0; results.forEach(e => cache.push(e)) }
        return done(results)
      })
  },

  // Build an elevation-profile point array from a line's coords + per-vertex elevations:
  // cumulative haversine distance (m), elevation (m), and segment grade (%). Matches the
  // shape TrackChart consumes so the line profile looks like a track's.
  buildLineProfile(coords, elevations) {
    const R = 6378137 // matches google.maps spherical earth radius
    const toRad = d => (d * Math.PI) / 180
    const seg = (a, b) => {
      const lat1 = toRad(a.lat()), lat2 = toRad(b.lat())
      const dLat = lat2 - lat1, dLng = toRad(b.lng() - a.lng())
      const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2
      return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)))
    }
    const pts = []
    let cum = 0
    for (let i = 0; i < coords.length; i++) {
      const elevM = Number(elevations[i]) || 0
      let gradePct = 0
      if (i > 0) {
        const d = seg(coords[i - 1], coords[i])
        cum += d
        const dE = elevM - (Number(elevations[i - 1]) || 0)
        gradePct = d > 0 ? (dE / d) * 100 : 0
      }
      pts.push({ distM: cum, elevM, gradePct })
    }
    if (pts.length > 1) pts[0].gradePct = pts[1].gradePct
    return pts
  },

  getElevationGainIncremental(shape, token, cache, ignoreCount = 0) {
    if (typeof shape?.getPath !== "function") return Promise.reject('no path')
    const coords = shape.getPath().getArray().slice(0, shape.getPath().getLength() - ignoreCount)
    const computeGain = eles => {
      let gain = 0
      for (let i = 0; i < eles.length - 1; i++) {
        if (eles[i + 1] > eles[i]) gain += eles[i + 1] - eles[i]
      }
      return gain
    }
    if (cache.length === coords.length - 1) {
      const newCoord = coords[coords.length - 1]
      return elevation.getElevation(newCoord.lat(), newCoord.lng(), token).then(newEle => {
        cache.push(newEle)
        return computeGain(cache)
      })
    }
    return Promise.all(coords.map(coord => elevation.getElevation(coord.lat(), coord.lng(), token)))
      .then(results => {
        cache.length = 0
        results.forEach(e => cache.push(e))
        return computeGain(results)
      })
  }
}